import './index.css'

import React from 'react'
import {render} from 'react-dom'
require('react-web-vector-icons/fonts');

import App from './App'

render(<App/>, document.querySelector('#app'))
